import { Family } from "@joonapp/web-shared"

import { AddChildRequest, FamilyMail } from "../../types"
import {
  CancelActionContent,
  CancelFlowModalType,
  CancelFlowStep,
  CancelFlowStepType,
} from "../../types/cancelFlow"
import { createJoonAPIClient } from "../../util/joon-api"

export async function addChild({
  childInfo,
  familyId,
}: {
  childInfo: AddChildRequest
  familyId: number
}) {
  const API = createJoonAPIClient()
  return API.post(`api/families/${familyId}/create-child/`, childInfo).then(
    (res) => res.data
  )
}

export async function removeChild({
  childId,
  familyId,
}: {
  childId: number
  familyId: number
}) {
  const API = createJoonAPIClient()
  return API.post(`api/families/${familyId}/remove-member/`, {
    user_id: childId,
  }).then((res) => res.data)
}

export async function loadFamilies() {
  const joonApiClient = createJoonAPIClient()
  try {
    const response = await joonApiClient.get<{ results: Family[] }>(
      "api/families/"
    )
    return response.data.results[0]
  } catch (error) {
    throw error
  }
}

export const getMostRecentMail = async () => {
  const API = createJoonAPIClient()
  return API.get<{
    recent_messages: FamilyMail[]
  }>(`api/family-mails/recent/`).then((res) => res.data.recent_messages)
}

export const cancelJoonitySubscription = async ({
  flowStepType,
  familyId,
}: {
  flowStepType: CancelFlowStepType
  familyId: number
}) => {
  const API = createJoonAPIClient()
  return API.post<CancelActionContent>(`api/families/${familyId}/cancel/`, {
    flow_step_type: flowStepType,
  }).then((res) => res.data)
}

export async function getCancelFlow(
  cancelFlowType: CancelFlowModalType,
  familyId?: number // undefined because coaching type doesn't use family ID
) {
  const API = createJoonAPIClient()
  switch (cancelFlowType) {
    case CancelFlowModalType.JOONITY:
      if (!familyId) throw new Error("Family ID is required")
      return API.get<{ steps: CancelFlowStep[] }>(
        `api/families/${familyId}/cancel-flow/`,
        {
          params: {
            use_churnkey: false,
          },
        }
      ).then((res) => res.data.steps)
    case CancelFlowModalType.COACHING:
      return API.get<{ steps: CancelFlowStep[] }>(
        `api/coaching-groups/cancel-flow/`,
        {
          params: {
            use_churnkey: false,
          },
        }
      ).then((res) => res.data.steps)
    default:
      throw new Error("Invalid cancel flow type")
  }
}
